import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

import CustomButtonGroup from '../../components/CustomButtonGroup/CustomButtonGroup';
import {ConfigConstant} from '../../constants/config';
import {pxToRem} from '../../utils';

const StyledWrapperDiv = styled('div')(({theme}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100%',
  backgroundColor: theme.palette.grey[200],
}));

const StyledWrapperInnerDiv = styled('div')(({theme}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  '& > *': {
    flex: `1 1 100%`,
  },
  '& .custom-button-group': {
    maxWidth: 300,
    margin: 'auto',
  },
}));

const StyledTypography = styled(Typography)(({theme}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 800,
  fontSize: pxToRem(32),
  color: theme.palette.primary.dark,
}));

const NotFound = ({permissions}) => {
  const onRetry = () => {
    window.location.reload();
  };
  return (
    <StyledWrapperDiv>
      <StyledWrapperInnerDiv>
        <StyledTypography>{permissions ? 'Permission required' : '404 - Not Found'}</StyledTypography>
        <CustomButtonGroup
          first={{
            text: 'Retry',
            variant: 'outlined',
            onClick: onRetry,
          }}
          second={{
            text: permissions ? 'Login page' : 'Go Back',
            variant: 'contained',
            onClick: () => {
              permissions ? (window.location.href = ConfigConstant.PLATFORM_URL) : window.history.back();
            },
          }}
        />
      </StyledWrapperInnerDiv>
    </StyledWrapperDiv>
  );
};

export default NotFound;
